var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1973E8",
    d: "M15.6 13.8v-6A1.8 1.8 0 0 0 13.8 6h-6A1.8 1.8 0 0 0 6 7.8v6a1.8 1.8 0 0 0 1.8 1.8h6a1.8 1.8 0 0 0 1.8-1.8Zm-8.4 0v-6a.6.6 0 0 1 .6-.6h6a.6.6 0 0 1 .6.6v6a.6.6 0 0 1-.6.6h-6a.6.6 0 0 1-.6-.6Zm10.2-5.4a.6.6 0 0 0-.6.6v6a1.8 1.8 0 0 1-1.8 1.8H9A.6.6 0 1 0 9 18h6a3 3 0 0 0 3-3V9a.6.6 0 0 0-.6-.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  })))));
};
export default SvgCopyIcon;